<template>
  <div class="sso-error">
    <div class="sso-error-message">{{ message }}</div>
    <div v-if="showSupport" class="sso-error-support">
      Sorun devam ederse <a href="mailto:destek@uesturkiye.com">destek@uesturkiye.com</a> adresinden bize ulaşabilirsiniz.
    </div>
  </div>
</template>

<script>
/**
 * SSO/OCL bileşenlerinin (KidzwonderJr, Kidzwonder3D, ...) ortak hata gösterimi.
 * Backend'den gelen mesaj (ör. lisans/yetki reddi) burada gösterilir, altına her
 * zaman destek iletişim satırı eklenir — kullanıcı platforma neden giremediğini
 * görüp gerekirse doğrudan destek ekibine ulaşabilir.
 */
export default {
  name: "SsoError",
  props: {
    message: { type: String, required: true },
    showSupport: { type: Boolean, default: true },
  },
}
</script>

<style scoped>
.sso-error-message {
  max-width: 520px;
  margin: 20px auto;
  color: #b3261e;
  font-weight: 600;
}

.sso-error-support {
  max-width: 420px;
  margin: 12px auto 0;
  font-size: 14px;
  color: #444;
}

.sso-error-support a {
  color: #712481;
  text-decoration: underline;
  font-weight: 600;
}
</style>
